module.exports = __webpack_public_path__ + "img/journey-mobile.d7669be1.png";